import { createStore } from 'vuex'
import auth from './auth'
import clientInvoicePayments from './clientInvoicePayments'
import clients from './clients/index'
import dashbord from './dashbord/index'
import instagram from './instagram/index'
import links from './links/index'
import offers from './offers/index'
import payments from './payments/index'
import storeGroups from './storeGroups'
import storeInvoicePayments from './storeInvoicePayments'
import stores from './stores/index'
import trafficSources from './trafficSources'
import user from './user'
import users from './users/index'

export default createStore({
  modules: {
    user,
    users,
    links,
    storeGroups,
    stores,
    clients,
    offers,
    instagram,
    payments,
    dashbord,
    storeInvoicePayments,
    clientInvoicePayments,
    trafficSources,
    auth,
  },
})
